import { FC, useEffect } from 'react';
import { trackPageView } from '../../utils/analytics';
import { View } from '../../types';
import { userLogsService } from '../../services/userLogsService';
import { useFirebaseAuth } from '../../contexts/FirebaseAuthContext';

interface AnalyticsRouterProps {
    currentView: View;
    subView: string | null;
}

/**
 * Компонент-невидимка для отслеживания навигации:
 * 1. Яндекс Метрика (SPA)
 * 2. Firebase User Logs (Внутренний аудит)
 */
export const AnalyticsRouter: FC<AnalyticsRouterProps> = ({ currentView, subView }) => {
    const { user } = useFirebaseAuth();

    useEffect(() => {
        // Формируем читаемый URL
        let virtualUrl = '/' + currentView.toLowerCase();

        if (subView) {
            virtualUrl += '/' + subView.toLowerCase();
        }

        // 1. Яндекс Метрика
        trackPageView(virtualUrl);

        // 2. Firebase Logs
        // Log VIEW action
        userLogsService.logActivity(
            'VIEW',
            `Просмотр раздела: ${currentView} ${subView ? `(${subView})` : ''}`,
            user,
            virtualUrl
        );

    }, [currentView, subView, user]); // User dependency ensures we log with user info if it becomes available

    return null;
};
